import DataGrid from '../components/data-grid/index';
import DataGridPrint from '../components/data-grid/print';
import PrintDataGrid from '../components/print-data-grid';
import HomePage from '../components/home-page/index.vue';
import DataGridPage from '../pages/data-grid';
import Home from '../pages/home';
import HomeNew from '../pages/home-new';
import calendar from '../pages/calendar.vue';
import TodaySessions from '../pages/today-sessions.vue';

import ar from '@/local/ar.js';

export default [
  {
    path: '/old-home',
    name: 'old-home',
    component: Home,
    meta: { noTitle: true },
  },
  {
    path: '/',
    name: 'home',
    component: HomeNew,
    meta: {
      breadcrumbs: {
        getter: 'GlobalModule/getRouteName',
        isDynamic: true,
        pathParams: { navItem: 'navItem' },
      },
      noTitle: true,
    },
  },
  {
    path: '/requests',
    name: 'requests',
    component: HomePage,
    meta: {
      targetTab: '#tab-3',
      breadcrumbs: {
        getter: 'GlobalModule/getRouteName',
        isDynamic: true,
        pathParams: { navItem: 'navItem' },
      },
      noTitle: true,
    },
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: calendar,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.sessions,
        isDynamic: false,
      },
      noTitle: true,
    },
  },
  {
    path: '/today-sessions',
    name: 'today-sessions',
    component: TodaySessions,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.sessions,
        isDynamic: false,
      },
      noTitle: true,
    },
  },
  {
    path: '/data-grid/:navItem',
    name: 'data-grid',
    component: DataGridPage,
    meta: {
      breadcrumbs: {
        getter: 'GlobalModule/getRouteName',
        isDynamic: true,
        pathParams: { navItem: 'navItem' },
      },
      noTitle: true,
    },
    children: [
      {
        path: ':navSubMenuItem',
        name: 'data-grid-sub',
        component: DataGrid,
        meta: {
          breadcrumbs: {
            getter: 'GlobalModule/getRouteName',
            isDynamic: true,
            pathParams: { navSubMenuItem: 'navSubMenuItem' },
          },
        },
      },
      {
        path: ':navSubMenuItem/print',
        name: 'data-grid-print',
        component: DataGridPrint,
        props: route => ({ query: route.query }),
        meta: { noLayoutRequired: true },
      },
    ],
  },
  {
    path: '/print-data-grid',
    name: 'print-data-grid',
    component: PrintDataGrid,
    props: route => ({ query: route.query }),
    meta: { noLayoutRequired: true },
  },
];
